<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <h2 class="dark--text font-weight-bold">Set Menu Customer List</h2>
      </v-flex>
    </v-layout>
    <v-layout class="mt-2 ms-n5 ps-5 ps-sm-0" wrap>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="deliveryStatuses" v-model="deliveryStatus" item-value="value" item-text="text" filled label="All" solo dense attach></v-select>
      </v-flex>
      <v-flex xs8 sm3 md1 lg2 class="ml-2">
        <v-select :items="['All', 'MORNING', 'EVENING']" v-model="deliveryShift" item-value="value" item-text="text" filled label="All" solo dense attach></v-select>
      </v-flex>

      <v-flex xs8 sm3 md1 lg3 class="ml-2">
        <v-select :items="driverList" v-model="driverId" item-value="_id" clearable deletable-chips label="Driver" dense solo>
          <template slot="selection" slot-scope="data">
            <!-- HTML that describe how select should render selected items -->
            {{ data.item.user.firstnameEn }} - {{ data.item.user.lastnameEn }}
          </template>
          <template slot="item" slot-scope="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.user.firstnameEn }} - {{ data.item.user.lastnameEn }}
          </template>
        </v-select>
      </v-flex>
    </v-layout>

    <v-layout class="mt-2 ms-n5 ps-5 ps-sm-0" wrap>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="fieldsToSearch" v-model="fieldToSearch" item-text="key" item-value="value" label="Field To Search" dense attach solo></v-select>
      </v-flex>
      <v-flex xs8 sm3 md1 lg2 class="ml-2">
        <v-text-field placeholder="Search.." v-model="search" solo dense @keydown.enter="runSearch()"> </v-text-field>
      </v-flex>

      <v-flex xs8 sm3 md1 lg3 class="ml-2">
        <v-btn class="ms-sm-5 light--text text-capitalize" color="primary" width="150" @click="searchDelivery">Search </v-btn>
      </v-flex>
    </v-layout>
    <v-layout class="ml-n2">
      <v-flex xs8 sm3 md4 lg4 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <DownloadReports :hasData="hasData" :deliveryStatus="deliveryStatus" :deliveryShift="deliveryShift" :reportId="this.$route.query.reportId" />
      </v-flex>
    </v-layout>
    <v-container fluid class="mt-5 ml-n3">
      <v-data-table
        :mobile-breakpoint="0"
        id="myTable"
        :headers="headers"
        :items="orderDeliveryDetails"
        :loading="loading"
        item-key="slNo"
        :options.sync="options"
        class="mt-6 elevation-1"
        :server-items-length="totalCount"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
        :search="search"
      >
        <template v-slot:item.customerName="{ item }">
          <span v-if="item.customer">
            {{ item.customer.user.firstnameEn[0].toUpperCase() + item.customer.user.firstnameEn.substring(1) }}
            {{ item.customer.user.lastnameEn[0].toUpperCase() + item.customer.user.lastnameEn.substring(1) }}
          </span>
        </template>
        <template v-slot:item.customerId="{ item }"> #{{ padLeft(item.customer.customerId, 4) }} </template>
        <template v-slot:item.tags="{ item }">
          <span v-if="item.customer.tags">
            <v-row v-for="tag in item.customer.tags" :key="tag._id">
              {{ tag.name }}
            </v-row>
          </span>
        </template>
        <template v-slot:item.area="{ item }">
          <CustomerAddressColumn :addresses="item.address" type="area" />
        </template>

        <template v-slot:item.block="{ item }">
          <CustomerAddressColumn :addresses="item.address" type="block" />
        </template>

        <template v-slot:item.building="{ item }">
          <CustomerAddressColumn :addresses="item.address" type="building" />
        </template>
        <template v-slot:item.deliveryDate="{ item }">
          {{ getDate(new Date(parseFloat(item.deliveryDate))) | moment("MMM DD YYYY") }}
        </template>

        <template v-slot:item.shift="{ item }">
          {{ item.shift }}
        </template>
        <template v-slot:item.agent="{ item }">
          <span v-if="item.driver"> {{ item.driver.user.firstnameEn }} {{ item.driver.user.lastnameEn }} </span>
        </template>
        <template v-slot:item.status="{ item }">
          {{ getDeliveryStatus(item.delivery_status) }}
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import { DATE_FORMAT, TIME_ZONE } from "../../utils/utils";
import CustomerAddressColumn from "../../delivery/components/AddressColumn.vue";
import DownloadReports from "../components/DownloadReports.vue";
export default {
  components: { CustomerAddressColumn, DownloadReports },

  apollo: {
    getAllDrivers() {
      return {
        query: require("../../reports/api/getAllDrivers.graphql"),
        variables: {
          limit: 10000,
          skip: 0,
          searchKey: "",
        },
        result({ data, loading }) {
          this.loading = loading;
          this.driverList = data.getAllDrivers.drivers;
        },
      };
    },
  },
  watch: {
    "$route.query.masterId": {
      handler() {
        console.log("this.$route.query.masterId", this.$route.query.masterId);
        this.getDeliveryDetailsByDate();
      },
    },

    options: {
      handler() {
        this.limit = this.options.itemsPerPage;
        this.skip = this.options.page * this.options.itemsPerPage - this.options.itemsPerPage;
        this.getSetMenuCustomerDeliveryList();
      },
      deep: true,
    },
  },

  methods: {
    searchDelivery() {
      this.getSetMenuCustomerDeliveryList();
    },
    getDeliveryStatus(deliveryStatus) {
      if (deliveryStatus == "PENDING") {
        deliveryStatus = "Pending";
      }
      if (deliveryStatus == "DELIVERED") {
        deliveryStatus = "Delivered";
      }
      if (deliveryStatus == "NOT_DELIVERED") {
        deliveryStatus = "Not Delivered";
      }
      return deliveryStatus;
    },
    getDate(date) {
      let converted = moment(date).tz(TIME_ZONE);
      return converted;
    },
    padLeft(number, length) {
      var stringValue = "" + number;
      while (stringValue.length < length) {
        stringValue = "0" + stringValue;
      }
      return stringValue;
    },
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getSetMenuCustomerDeliveryList() {
      debugger;
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getSetMenuCustomerDeliveryList.graphql"),
          variables: {
            reportId: this.$route.query.reportId,
            skip: this.skip,
            limit: this.limit,
            status: this.deliveryStatus,
            shift: this.deliveryShift,
            fieldToSearch: this.fieldToSearch,
            driverId: this.driverId,
          },
        })
        .refetch({
          variables: {
            reportId: this.$route.query.reportId,
            skip: this.skip,
            limit: this.limit,
            status: this.deliveryStatus,
            shift: this.deliveryShift,
            fieldToSearch: this.fieldToSearch,
            driverId: this.driverId,
          },
        })
        .then(data => {
          this.loading = false;
          this.hasData = true;

          this.orderDeliveryDetails = [];
          this.totalCount = 0;
          if (data.data.getSetMenuCustomerDeliveryList) {
            this.orderDeliveryDetails = data.data.getSetMenuCustomerDeliveryList.orderDelivery;
            this.totalCount = data.data.getSetMenuCustomerDeliveryList.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    driverId: "",
    btnloading: false,
    deliveryStatus: "All",
    search: "",
    deliveryShift: "MORNING",
    orderDeliveryDetails: [],
    fieldToSearch: "",
    hasData: false,
    fieldsToSearch: [
      { key: "Customer Id", value: "CUSTOMER_ID" },
      { key: "Customer Name", value: "CUSTOMER_NAME" },
      { key: "Contact Number", value: "PHONE" },
    ],
    driverList: [],
    deliveryStatuses: [
      { text: "All", value: "All" },
      { text: "Pending", value: "PENDING" },
      { text: "Delivered", value: "DELIVERED" },
      { text: "Not Delivered", value: "NOT_DELIVERED" },
    ],
    skip: 0,
    limit: 25,
    totalCount: 0,
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    headers: [
      { text: "Q No.", value: "orderNumber", width: 50, sortable: false },
      {
        text: "Customer Name",
        value: "customerName",
        width: 150,
        sortable: false,
      },
      {
        text: "Customer Id",
        value: "customerId",
        width: 80,
        sortable: false,
      },
      { text: "Tags", value: "tags", sortable: false, width: 80 },
      {
        text: "Mobile",
        value: "customer.user.phone",
        sortable: false,
        width: 100,
      },
      { text: "Zone", value: "zone.zoneName", width: 150, sortable: false },
      { text: "Area", value: "area", width: 150, sortable: false },
      {
        text: "Block, Street, Jedha",
        value: "block",
        width: 220,
        sortable: false,
      },
      { text: "Building", value: "building", width: 200, sortable: false },

      { text: "Delivery Time", value: "shift", sortable: false, width: 150 },
      { text: "Delivery Agent", value: "agent", width: 150, sortable: false },
      {
        text: "Status",
        value: "status",
        width: 60,
        sortable: false,
      },
    ],
  }),
  computed: {
    itemsWithSno() {
      if (this.orderDeliveryDetails == null) return [];
      return this.orderDeliveryDetails.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
    formatDate() {
      return this.date ? moment(this.date).format(DATE_FORMAT) : "";
    },
  },
  created() {},
  mounted() {
    this.getSetMenuCustomerDeliveryList();
  },
};
</script>

<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
